import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { RowArgs } from '@progress/kendo-angular-grid';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { OrderService } from '../../../services/order.service';
import { v_OrderBus } from '../../../models/v_OrderBus';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'cp-order-review-grid',
    templateUrl: './order-review-grid.component.html',
    styleUrls: ['./order-review-grid.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrderReviewGridComponent extends BaseGridComponent<v_OrderBus, null> {

    subscriptions: Subscription[] = [];
    searchParam: WidgetSearch;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: OrderService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.subscriptions.push(svc_dashboard.dispatchReviewRefresh$.subscribe(
            refresh => {
                this.loaderState = true;
                this.getData();
            }));
    }

    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();

    loaderState: boolean = true;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    exportFilteredData: any[];

    initialLoad: boolean = true;

    ngOnInit() {
        this.setup(this.dataFilter);
        this.initialLoad = false;
    }

    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    public selectionKey(context: RowArgs): string {
        return context.dataItem.orderId;
    }
    getData() {
        this.loaderState = true;
        this.hideError();
        this.svc_data.GetOrderReviewDetail(this.searchParam).subscribe(data => {
            if (data == null || data.length == 0) {
                this.handleNetworkError(null);
            } else {
                this.data = data;

                this.originalGridData = _.cloneDeep(data);
                this.gridData = orderBy(filterBy(this.originalGridData, this.filter), this.sort);

                this.loaderState = false;
                this.reloadIds()
            }
        },
            error => this.handleNetworkError(error));
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loaderState = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    public setup(data: WidgetSearch) {
        this.searchParam = data;
        this.getData();
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }
    showDetailsPopup(id: string, type: number) {
        this.setReloadIds(id);
        this.svc_dashboard.openDQOIPopup(id, type);
    }
    showDispatchQVPopup(dispatch) {
        this.svc_dashboard.openDispatchQVPopup(dispatch);
    }
    showOrderQVPopup(order) {
        this.setReloadIds(order.orderId);
        this.svc_dashboard.openOrderQVPopup(order);
    }
    loadDispatchGeneric(value: any) {
        if (value.isConstruction) {
            if (value.isJob) {
                this.loadJob(value.dispatchId);
            }
            else {
                this.loadContract(value.dispatchId);
            }
        } else {
            this.loadDispatch(value.dispatchId);
        }
    }
    loadJob(id: any) {
        if (id) {
            let url: string = "/quickview/construction/10/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadContract(id: any) {
        if (id) {
            let url: string = "/quickview/construction/9/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadDispatch(id: any) {
        if (id) {
            let url: string = "/quickview/dispatch/1/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadOrder(value: any) {

        if (value.isConstruction) {
            this.loadOrderContruction(value.orderId);

        } else {
            this.loadOrderService(value.orderId);

        }

    }
    loadOrderContruction(id: any) {
        if (id) {
            let url: string = "/quickview/construction/3/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    loadOrderService(id: any) {
        if (id) {
            let url: string = "/quickview/service/3/" + id;
            console.log("url: ", url);
            this.navigate(url);
        }

    }
    navigate(url: string) {
        setTimeout(() => {
            window.open(url, "_blank");
        });
    }
}
